<div class="border-l-4"
     [ngClass]="[primaryColor | prefix:'border']">
  <span class="text-2xl font-medium mx-4">{{title}}</span>
</div>
